// Runtime config. In production deploy-frontend.sh writes .env.local from CFN
// exports; in local dev the redirect URI derives from the origin and the
// Cognito values come from .env.development (public identifiers, safe to commit).
export const config = {
  cognitoDomain: import.meta.env.VITE_COGNITO_DOMAIN as string,
  cognitoClientId: import.meta.env.VITE_COGNITO_CLIENT_ID as string,
  redirectUri:
    (import.meta.env.VITE_REDIRECT_URI as string | undefined) ??
    `${window.location.origin}/callback`,
  siteUrl: (import.meta.env.VITE_SITE_URL as string | undefined) ?? window.location.origin,
  apiUrl: import.meta.env.VITE_API_URL as string,
};
